var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":"","opacity":"0.7"}},[_c('h1',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":""}}),_c('br'),_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.login.loading'))+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }